export const MimeTypes = {
  APPLICATION_OCTET_STREAM: 'application/octet-stream'
};